// extracted by mini-css-extract-plugin
export default {"recordList":"recordList--bQeC_","emptyDesc":"emptyDesc--y1YWu"};